import { render, staticRenderFns } from "./Swatch.vue?vue&type=template&id=5432656c&scoped=true&"
import script from "./Swatch.vue?vue&type=script&lang=js&"
export * from "./Swatch.vue?vue&type=script&lang=js&"
import style0 from "./Swatch.vue?vue&type=style&index=0&id=5432656c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5432656c",
  null
  
)

export default component.exports